import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, styled, Typography } from '@mui/material';

import CustomButton from 'components/CustomButton';

export const DialogHeader = styled(DialogTitle)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const CloseDialogButton = styled(CustomButton)(({ theme }) => ({
  padding: theme.spacing(0.75, 0.75),
  minWidth: 'unset',
}));

export const CloseModalIcon = styled(CloseIcon)(({ theme }) => ({
  fontSize: theme.spacing(3),
}));

export const DialogHeaderText = styled(Typography)(() => ({
  fontSize: '1.5rem',
  fontWeight: 'bold',
}));
